<!-- login -->
<div class="registration-page">

  <div class="col-xs-12 loginForm">
    <div style = "text-align: center; margin-top: 10%;">
      <img class="lesteLogo" src="{{imageUrl}}">

      <!-- NIS LOGO -->
      <!-- <img  class="lesteLogo" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/LogoLESTE.png?alt=media&token=f8976808-1888-4484-948b-b6f268bdbee3" alt = "nis logo"> -->

      <!-- EMS LOGO -->
      <!-- <img class="emsLogo" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webImgs%2FEMS-logo.png?alt=media&token=3f718d73-023e-4c42-a778-eea9a52cefea"> -->
    </div>
    <div class="forma1">
      <div class="loginLabel">
        <h2 class="loginLabel">{{labels.lblSignUp}}</h2>
        @if (err) {
          <p style="color: red">{{labels.lblAllfieldsError}}</p>
        }
      </div>
      <form action="" #userLoginForm="ngForm" style = "margin-top: 7%;" (ngSubmit)="onSubmit(userLoginForm, false)">
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err1' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <img src = "./assets/icons/emailLoginIcon.png" alt = "email login icon">
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="email" ngModel #email="ngModel" placeholder = {{labels.lblEmail}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err3' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <mat-icon>person</mat-icon>
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="firstName" ngModel #firstName="ngModel" placeholder = {{labels.lblFirstName}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err4' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <mat-icon>person</mat-icon>
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="lastName" ngModel #lastName="ngModel" placeholder = {{labels.lblLastName}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err5' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <mat-icon>badge</mat-icon>
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="jmbg" ngModel #jmbg="ngModel" placeholder = {{labels.lblJmbg}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err6' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <mat-icon>location_city</mat-icon>
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="city" ngModel #city="ngModel" placeholder = {{labels.lblCity}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err7' appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <mat-icon>call</mat-icon>
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput required name="phoneNumber" ngModel #phoneNumber="ngModel" placeholder = {{labels.lblPhoneNumber}}>
          </span>
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err2' style = "margin-top: 5%; margin-bottom: 5%;" appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <img src = "./assets/icons/passwordLoginIcon.png" alt = "password login icon">
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput [type]="isActive ? 'password' : 'text'" required minlength="6" name="password" ngModel
              #password="ngModel" placeholder = {{labels.lblPassword}}>
          </span>
          @if (isActive) {
            <span class = "inputIcon" style = "float: right; margin-right: 11px; cursor: pointer;">
              <img (click) = "changeActive()" src = "./assets/icons/hidePasswordIcon.png" alt = "password icon hide">
            </span>
          }
          @if (!isActive) {
            <span class = "inputIcon" style = "float: right; margin-right: 11px; cursor: pointer;">
              <img (click) = "changeActive()" src = "./assets/icons/showPasswordIcon.png" alt = "password icon show">
            </span>
          }
        </mat-form-field>
        <mat-form-field class="no-line inputFieldForm" [class.redBorder] = 'err8' style = "margin-top: 5%; margin-bottom: 5%;" appearance="none">
          <span class = "inputIcon" style = "display: inline-block">
            <img src = "./assets/icons/passwordLoginIcon.png" alt = "password confirm icon">
          </span>
          <span style = "display: inline-block; vertical-align: middle; padding-left: 10px;">
            <input matInput [type]="isActive ? 'password' : 'text'" required minlength="6" name="confirmPassword" ngModel
              #confirmPassword="ngModel" placeholder = {{labels.lblConfirmPassword}}>
          </span>
          @if (isActive) {
            <span class = "inputIcon" style = "float: right; margin-right: 11px; cursor: pointer;">
              <img (click) = "changeActive()" src = "./assets/icons/hidePasswordIcon.png" alt = "password icon hide">
            </span>
          }
          @if (!isActive) {
            <span class = "inputIcon" style = "float: right; margin-right: 11px; cursor: pointer;">
              <img (click) = "changeActive()" src = "./assets/icons/showPasswordIcon.png" alt = "password icon show">
            </span>
          }
        </mat-form-field>
        <mat-checkbox class="example-margin" [(checked)]="checkedData" name="checked">{{ labels.lblAllFieldsCorrect }}</mat-checkbox>
        <mat-checkbox class="example-margin" [(checked)]="checkedTOS" name="accepted"><a target="_blank" routerLink="/terms-of-use" style="text-wrap: wrap">{{ labels.lblAcceptTerms }}</a></mat-checkbox>
        <button class="login-button" type="submit">
          <div class = "row">
            <div class = "col-1"></div>
            <div class = "col-9" style = "margin: auto; text-align: center;">
              <h3 class = "loginBtnLabel">{{labels.lblSignUp}}</h3>
            </div>
            <div class = "col-1"><img style = "float: right; padding-right: 15px;" src = './assets/icons/loginIcon.png' alt = "registration icon"></div>
          </div>
        </button>

        @if (wrongInfo) {
          <div class = "row" style = "width: 70%; margin: auto;">
            <div class = "col-12 wrongInfoDiv">
              {{labels.lblSignUpWrongDataMessage}}
            </div>
          </div>
        }

        <!-- <div class="row or">
        <div class="col-xs-5 col-sm-5" style="height:40px; padding-top:0"><div style="height:50%; border-bottom: 1px solid #CECDD8"></div></div>
        <div class="col-xs-2 col-sm-2" style="padding-top:10px; height:40px; text-align: center; margin: auto; color: #7F799B;">{{labels.lblOr}}</div>
        <div class="col-xs-5 col-sm-5" style="height:40px;text-align: center; margin: auto;"><div style="height:50%; border-bottom: 1px solid #CECDD8"></div></div>
      </div>
      <div class="row loginWith" (click) = "loginWithGoogle()" style="cursor: pointer; text-align: center;margin:auto;height:50px;margin-top: 1.5vh; font-family: Poppins; font-weight:normal;font-size:12px; background-color: white;text-transform: none; color: #7F799B; border: 1px solid #CECDD8; border-radius:7px">
        <div class="col-4 text-right" style="margin: auto;">
          <div style="float:right;height:20px;width:20px; background-size: contain; background-repeat:no-repeat; background-image: url('https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/google.png?alt=media&token=74affd5f-5cfc-467d-aca8-ed98372efd36')"></div></div>
          <div class="col-8 text-left" style="padding-left:0; margin:auto"><div style="font-family: Poppins; letter-spacing:1px;">{{labels.loginGoogle}}</div>
        </div>
      </div>
      <div class="row loginWith" (click) = "facebookLogin()" style="cursor: pointer; text-align: center;margin:auto;height:50px;margin-top: 1.5vh; font-family: Poppins; font-weight:normal;font-size:12px; background-color: white;text-transform: none; color: #7F799B; border: 1px solid #CECDD8; border-radius:7px">
        <div class="col-4 text-right" style="margin: auto;">
          <div style="float:right;height:20px;width:20px; background-size: contain; background-repeat:no-repeat; background-image: url('https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/facebookIcon.png?alt=media&token=a2fa1832-8eab-4dd1-9672-d137cabc35dd')"></div></div>
          <div class="col-8 text-left" style="padding-left:0; margin:auto"><div style="font-family: Poppins; letter-spacing:1px;">{{labels.loginFacebook}}</div>
        </div>
      </div> -->
      <!-- <div class="dontHaveAnAccount">{{labels.lblDontHaveAccount}} <span style="color: rgb(241,106,100)" (click) = "openRegisterModal()">{{labels.lblSignUp}}</span></div> -->
    </form>
  </div>

</div>
</div>
